<template>
  <div>
    <div class="folder-container" @click="showChildren = !showChildren">
      <span class="title-box" :title="item.title">
        <b-icon-folder />
        {{ item.title }}
      </span>
    </div>
    <b-collapse v-model="showChildren" >
      <div class="ml-3">
        <div v-for="report in item.reports" :key="report.tableauMenuConfigId">
          <report-node :report="report" />
        </div>
      </div>
      <tree-node
        class="ml-3"
        v-if="item.children && item.children.length"
        :items="item.children"
      />
    </b-collapse>
  </div>
</template>

<script>
import reportNode from './ReportNode.vue';

export default {
  name: 'SingleNode',
  components: { reportNode, TreeNode: () => import('./TreeNode.vue') },
  props: { item: Object },
  data() {
    return {
      showChildren: false
    }
  }
};
</script>

<style scoped>
.icon-button {
  visibility: hidden;
  display: inline-block;
  cursor: pointer;
  float: right;
  vertical-align: bottom;
  z-index: 10;
}

.title-box {
  display: inline-block;
  width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.title-box:visited {
  color: inherit !important;
}

.title-box:focus {
  color: inherit !important;
}

.title-box:hover {
  color: inherit !important;
  text-decoration: none !important;
}
</style>